export enum CatalogCategoryLevelEnum {
  PARENT,
  CHILD,
}
